<template>
    <div>
      <!-- modal -->
      <b-modal id="lawMatterProcessResultFormModal" ref="lawMatterProcessResultFormModal" centered size="lg" no-close-on-backdrop :title=" $t('lawMatterProcessResult.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
          <b-row>
            <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('lawMatterProcessResult.law_matter_type_name') }}</label>
                        <b-form-group>
                            <validation-provider :name=" $t('lawMatterProcessResult.law_matter_type_name')" :rules="{ excluded:0}" v-slot="{ errors }">
                            <b-form-select :state="errors.length > 0 ? false:null"  size="sm" v-model="lawMatterTypeSelect" value-field="id" text-field="name" :options="lawMatterTypeOptions" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
            </b-col>
             <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('lawMatterProcessResult.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('lawMatterProcessResult.name')" rules="required">
                                <b-form-input  size="sm" v-model="name" maxlength="100" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
          </b-row>
          <b-row>
            <b-col class="col-lg-12">
              <b-form>
                  <label>{{ $t('lawMatterProcessResult.description') }}</label>
                  <b-form-group>
                      <b-form-input  size="sm" v-model="description" maxlength="200"/>
                  </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getLawMatterProcessResultList: {type: Function},
    },
    data() {
      return {
        id: 0,
        lawMatterTypeOptions: [],
        lawMatterTypeSelect: 0,
        name :'',
        description: ''
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['lawMatterProcessResultFormModal'].show()
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'LawMatterProcessResult'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.name = response.data.lawMatterProcessResult.name
                this.description = response.data.lawMatterProcessResult.description

                this.lawMatterTypeOptions = response.data.lawMatterTypeList
                this.lawMatterTypeOptions.splice(0, 0, this.$nullSelected())
                this.lawMatterTypeSelect = response.data.lawMatterProcessResult.lawMatterTypeId
                
            } else {
                this.$bvModal.hide('lawMatterProcessResultFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, name: this.name,description:this.description,lawMatterTypeId :this.lawMatterTypeSelect}
        const controller = {name : 'LawMatterProcessResult'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$store.dispatch('moduleAuth/save',payload).then((response) => {
            if(response.data.resultStatus == true){
                this.$bvModal.hide('lawMatterProcessResultFormModal')
                this.getLawMatterProcessResultList()
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  